export default [
  {
    path: '/',
    redirect: '/index/home'
  },
  {
    path: '/index',
    name: 'index',
    // component: () => import('@/views/ReportDay/index.vue'),
    component: () => import('@/views/Home/index.vue'),
    children: [
      {
        path: 'policy',
        name: 'policy',
        component: () => import('@/views/Policy/index.vue'),
        meta: { title: "政策法规" },
      },
      {
        path: 'question',
        name: 'question',
        component: () => import('@/views/Question/index.vue'),
      },
      // 当 /user/:id 匹配成功
      // UserHome 将被渲染到 User 的 <router-view> 内部
      {
        path: 'home', component: () => import('@/views/Home/home.vue'),
        meta: { title: "首页" },
      },
      {
        path: 'application',
        name: 'application',
        component: () => import('@/views/Application/index.vue'),
        meta: { title: "申请" },

      },
      {
        path: 'position/:id/:typeId',
        name: 'position',
        component: () => import('@/views/Position/index.vue'),
        meta: { title: "岗位" },

      },
      {
        path: 'exam',
        name: 'exam',
        component: () => import('@/views/Exam/index.vue'),
        meta: { title: "考试" },
      },
      {
        path: 'notice/:id/:postId/:typeId',
        name: 'notice',
        component: () => import('@/views/Notice/index.vue'),
        meta: { title: "通知" },
      },
      {
        path: 'userInfoWrite/:id/:postId',
        name: 'userInfoWrite',
        component: () => import('@/views/UserInfoWrite/index.vue'),
        meta: { title: "报名" },
      },
      // ...其他子路由
    ],
  },
  {
    path: '/regist',
    name: 'regist',
    component: () => import('@/views/Regist/index.vue'),
  },
  {
    path: '/forget',
    name: 'forget',
    component: () => import('@/views/Forget/index.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/index.vue'),
  },


  {
    path: '/user',
    name: 'user',
    component: () => import('@/views/user/index.vue'),
    redirect: '/user/review',
    children: [
      // 当 /user/:id 匹配成功
      // UserHome 将被渲染到 User 的 <router-view> 内部
      { path: 'review', component: () => import('@/views/user/review.vue') },
      { path: 'update', component: () => import('@/views/user/update.vue') },
      { path: 'pay', component: () => import('@/views/user/pay.vue') },
      { path: 'print', component: () => import('@/views/user/print.vue') },
      { path: 'select', component: () => import('@/views/user/select.vue') },
      { path: 'setting', component: () => import('@/views/user/setting.vue') },
      // { path: 'resume', component: () => import('@/views/user/resume.vue') },
      // ...其他子路由
    ],
  },
  {
    path: '/pinia',
    name: 'pinia',
    component: () => import('@/views/PiniaView.vue'),
  },
];
